import { translateKey } from '../../../translate';

export const proces = {
    name: 'Proces',
    data: [
        {
            label: 'Proces ID',
            badgeText: '',
            value: 'proces-procesId',
            key: 'processId',
        },
        {
            label: 'TxCS proces ID',
            badgeText: '',
            value: 'proces-txcsProcesId',
            key: 'txcsProcesId',
        },
        {
            label: 'Migratiedatum',
            badgeText: '',
            value: 'proces-migratiedatum',
            key: 'migrationDateTime',
        },
        {
            label: 'Mogelijk testgeval',
            badgeText: '',
            value: 'proces-mogelijkTestgeval',
            key: 'processTestCase',
        },
        {
            label: 'Dienst',
            badgeText: '',
            value: 'proces-dienst',
            key: 'serviceName',
        },
        {
            label: 'Dienstsoort',
            badgeText: '',
            value: 'proces-dienstsoort',
            key: 'serviceType',
        },
        {
            label: 'Indirecte aanvraag',
            badgeText: '',
            value: 'proces-indirecteAanvraag',
            key: 'isDirectProcedureAdded',
        },
        {
            label: 'Creatiedatum',
            badgeText: '',
            value: 'proces-creatiedatum',
            key: 'creatieDatum',
        },
        {
            label: 'Status',
            badgeText: '',
            value: 'proces-status',
            key: 'status',
        },
        {
            label: 'Aanvraag verzonden',
            badgeText: '',
            value: 'proces-aanvraagVerzonden',
            key: 'datumVerzending',
        },
        {
            label: 'Sluitdatum',
            badgeText: '',
            value: 'proces-sluitdatum',
            key: 'sluitDatum',
        },
        {
            label: 'Reden geen bekosting',
            badgeText: '',
            value: 'proces-redenGeenBekosting',
            key: 'reasonNoInvoiceOrDeclaration',
        },
        {
            label: 'Reden geen bek. ingest.',
            badgeText: '',
            value: 'proces-redenGeenBekIngest',
            key: 'fundingMutationReason',
        },
        {
            label: 'Bekostingsfout',
            badgeText: '',
            value: 'proces-bekostingsfout',
            key: 'fundingError',
        },
        {
            label: 'Afhandelingsinformatie',
            badgeText: '',
            value: 'proces-afhandelingsinformatie',
            key: 'fundingErrorInformation',
        },
        {
            label: 'Anders doorverwezen?',
            badgeText: '',
            value: 'proces-andersDoorverwezen',
            key: 'evaluationOtherwiseReferPatient',
        },
        {
            label: 'Alsnog doorverwijzen?',
            badgeText: '',
            value: 'proces-alsnogDoorverwijzen',
            key: 'evaluationAfterwardsReferPatient',
        },
        {
            label: 'Geholpen?',
            badgeText: '',
            value: 'proces-geholpen',
            key: 'evaluationReportHelpful',
        },
        {
            label: 'Leerzaam?',
            badgeText: '',
            value: 'proces-leerzaam',
            key: 'evaluationReportInstructive',
        },
        {
            label: '=> consult?',
            badgeText: '',
            value: 'proces-consult',
            key: 'previousRequestId',
        },
        {
            label: 'Aanvraag ontvanger',
            badgeText: '',
            value: 'proces-aanvraagOntvanger',
            key: 'recipientOrganizationName',
        },
    ],
};

export const aanvraag = {
    name: 'Aanvraag',
    data: [
        {
            label: 'Verzenddatum',
            badgeText: '',
            value: 'aanvraag-verzenddatum',
            key: 'dateSent',
        },
        {
            label: 'Reden geen uitb.',
            badgeText: '',
            value: 'aanvraag-redenGeenUitb',
            key: 'requestPayoutError',
        },
        {
            label: 'Reden geen uitb. ingest.',
            badgeText: '',
            value: 'aanvraag-redenGeenUitbIngest',
            key: 'requestPayoutMutationReason',
        },
        {
            label: 'Aanv. organisatie ID',
            badgeText: '',
            value: 'aanvraag-aanvOrganisatieId',
            key: 'requesterOrganizationTxcsId',
        },
        {
            label: 'Aanv. organisatienaam',
            badgeText: '',
            value: 'aanvraag-aanvOrganisatienaam',
            key: 'requesterOrganizationName',
        },
        {
            label: 'Verwijst naar',
            badgeText: '',
            value: 'aanvraag-verwijstNaar',
            key: 'refersTo',
        },
        {
            label: 'Aanv. org. relatienr.',
            badgeText: '',
            value: 'aanvraag-aanvOrgRelatienr',
            key: 'requesterOrganizationRelationNumber',
        },
        {
            label: 'Aanv. org. prijs',
            badgeText: '',
            value: 'aanvraag-aanvOrgPrijs',
            key: 'requesterServiceOrganizationSettingCompensationPayoutRequest',
        },
        {
            label: 'Aanv. org. emailadres',
            badgeText: '',
            value: 'aanvraag-aanvOrgEmailadres',
            key: 'requesterOrganizationEmailAddressRequestInbox',
        },
        {
            label: 'Aanv. org. fin. email',
            badgeText: '',
            value: 'aanvraag-aanvOrgFinEmail',
            key: 'requesterOrganizationEmailAddressPayouts',
        },
        {
            label: 'Aanv. grp. naam',
            badgeText: '',
            value: 'aanvraag-aanvGrpNaam',
            key: 'groupName',
        },
        {
            label: 'Aanv. grp. relatienr.',
            badgeText: '',
            value: 'aanvraag-aanvGrpRelatienr',
            key: 'groupRelationNumber',
        },
        {
            label: 'Aanv. grp. fin. email',
            badgeText: '',
            value: 'aanvraag-aanvGrpFinEmail',
            key: 'groupFinancialEmailAddress',
        },
        {
            label: 'Aanv. grp. prijs',
            badgeText: '',
            value: 'aanvraag-aanvGrpPrijs',
            key: 'compensationPayoutRequestGroupSetting',
        },
        {
            label: 'Aanvrager ID',
            badgeText: '',
            value: 'aanvraag-aanvragerI',
            key: 'requesterPractitionerUid',
        },
        {
            label: 'Aanvragernaam',
            badgeText: '',
            value: 'aanvraag-aanvragernaam',
            key: 'requesterPractitionerName',
        },
        {
            label: 'Uitv. prijs',
            badgeText: '',
            value: 'aanvraag-uitvPrijs',
            key: 'serviceConsumerCompensationPayoutRequest',
        },
        {
            label: 'Uitv. relatienr',
            badgeText: '',
            value: 'aanvraag-uitvRelatienr',
            key: 'requesterEmploymentRelationNumber',
        },
        {
            label: 'Pers. Emailadres',
            badgeText: '',
            value: 'aanvraag-persEmailadres',
            key: 'requesterEmploymentEmailAddress',
        },
        {
            label: 'Financieel emailadres',
            badgeText: '',
            value: 'aanvraag-financieelEmailadres',
            key: 'requesterEmploymentEmailAddressPayouts',
        },
    ],
};

export const patient = {
    name: 'Patient',
    data: [
        {
            label: 'Patient ID',
            badgeText: '',
            value: 'patient-patientId',
            key: 'patientId',
        },
        {
            label: 'Huisartsnaam',
            badgeText: '',
            value: 'patient-huisartsnaam',
            key: 'careProviderPractitioner',
        },
    ],
};

export const biometrie = {
    name: 'Biometrie',
    data: [
        {
            label: 'Verzenddatum',
            badgeText: '',
            value: 'biometrie-verzenddatum',
            key: 'procedureDate',
        },
        {
            label: 'Reden geen uitb.',
            badgeText: '',
            value: 'biometrie-redenGeenUitb',
            key: 'procedurePayoutError',
        },
        {
            label: 'Reden geen uitb. ingest.',
            badgeText: '',
            value: 'biometrie-redenGeenUitbIngest',
            key: 'procedurePayoutMutationReason',
        },
        {
            label: 'Uitv. grp. naam',
            badgeText: '',
            value: 'biometrie-uitvGrpNaam',
            key: 'nameGroupProcedure',
        },
        {
            label: 'Uitv. grp. relatienr.',
            badgeText: '',
            value: 'biometrie-uitvGrpRelatienr',
            key: 'relationNumberGroupProcedure',
        },
        {
            label: 'Uitv. grp. fin. email',
            badgeText: '',
            value: 'biometrie-uitvGrpFinEmail',
            key: 'financialEmailAddressGroupProcedure',
        },
        {
            label: 'Uitv. grp. prijs',
            badgeText: '',
            value: 'biometrie-uitvGrpPrijs',
            key: 'compensationPayoutProcedureGroupSetting',
        },
        {
            label: 'Uitv. organisatie ID',
            badgeText: '',
            value: 'biometrie-uitvOrganisatieId',
            key: 'procedureOrganizationTxcsId',
        },
        {
            label: 'Uitv. organisatienaam',
            badgeText: '',
            value: 'biometrie-uitvOrganisatienaam',
            key: 'procedureOrganizationName',
        },
        {
            label: 'Uitv. org. relatienr',
            badgeText: '',
            value: 'biometrie-uitvOrgRelatienr',
            key: 'procedureOrganizationRelationNumber',
        },
        {
            label: 'Uitv. org. prijs',
            badgeText: '',
            value: 'biometrie-uitvOrgPrijs',
            key: 'compensationPayoutBioOrganizationSetting',
        },
        {
            label: 'Uitv. org. emailadres',
            badgeText: '',
            value: 'biometrie-uitvOrgEmailadres',
            key: 'procedureOrganizationEmailAddressRequestInbox',
        },
        {
            label: 'Uitv. org. fin. email',
            badgeText: '',
            value: 'biometrie-uitvOrgFinEmail',
            key: 'procedureOrganizationEmailAddressPayouts',
        },
        {
            label: 'Uitv. biometrist ID',
            badgeText: '',
            value: 'biometrie-uitvBiometristId',
            key: 'procedurePractitionerUid',
        },
        {
            label: 'Uitv. biometristnaam',
            badgeText: '',
            value: 'biometrie-uitvBiometristnaam',
            key: 'procedurePractitionerName',
        },
        {
            label: 'Uitv. prijs',
            badgeText: '',
            value: 'biometrie-uitvPrijs',
            key: 'compensationPayoutBio',
        },
        {
            label: 'Uitv. relatienr',
            badgeText: '',
            value: 'biometrie-uitvRelatienr',
            key: 'procedureEmploymentRelationNumber',
        },
        {
            label: 'Pers. emailadres',
            badgeText: '',
            value: 'biometrie-persEmailadres',
            key: 'procedurePractitionerEmailAddress',
        },
        {
            label: 'Financieel emailadres',
            badgeText: '',
            value: 'biometrie-financieelEmailadres',
            key: 'procedureEmploymentEmailAddress',
        },
        {
            label: 'Revers. test afg.',
            badgeText: translateKey('common.sensitiveData'),
            value: 'biometrie-reversTestAfg',
            key: 'reverseTest',
        },
        {
            label: 'Ketenpatiënt',
            badgeText: translateKey('common.sensitiveData'),
            value: 'biometrie-ketenpatient',
            key: 'ketenPatient',
        },
        {
            label: 'Protocol',
            badgeText: translateKey('common.sensitiveData'),
            value: 'biometrie-protocol',
            key: 'protocol',
        },
        {
            label: 'Gedruppeld',
            badgeText: translateKey('common.sensitiveData'),
            value: 'biometrie-gedruppeld',
            key: 'patientGedruppeld',
        },
    ],
};

export const analist = {
    name: 'Analist',
    data: [
        {
            label: 'Uitv. organisatie ID',
            badgeText: '',
            value: 'analist-uitvOrganisatieId',
            key: 'holterAnalystOrganizationTxcsId',
        },
        {
            label: 'Uitv. organisatienaam',
            badgeText: '',
            value: 'analist-uitvOrganisatienaam',
            key: 'holterAnalystOrganizationName',
        },
        {
            label: 'Uitv. analist ID',
            badgeText: '',
            value: 'analist-uitvAnalistId',
            key: 'holterAnalystPractitionerUid',
        },
        {
            label: 'Uitv. analistnaam',
            badgeText: '',
            value: 'analist-uitvAnalistnaam',
            key: 'holterAnalystPractitionerName',
        },
    ],
};

export const grading = {
    name: 'Grading',
    data: [
        {
            label: 'Verzenddatum',
            badgeText: '',
            value: 'grading-verzenddatum',
            key: 'gradingDate',
        },
        {
            label: 'Reden geen uitb.',
            badgeText: '',
            value: 'grading-redenGeenUitb',
            key: 'gradingPayoutError',
        },
        {
            label: 'Reden geen uitb. ingest.',
            badgeText: '',
            value: 'grading-redenGeenUitbIngest',
            key: 'gradingPayoutMutationReason',
        },
        {
            label: 'Uitv. grp. naam',
            badgeText: '',
            value: 'grading-uitvGrpNaam',
            key: 'nameGroupReport',
        },
        {
            label: 'Uitv. grp. relatienr.',
            badgeText: '',
            value: 'grading-uitvGrpRelatienr',
            key: 'relationNumberGroupReportGrader',
        },
        {
            label: 'Uitv. grp. fin. email',
            badgeText: '',
            value: 'grading-uitvGrpFinEmail',
            key: 'financialEmailAddressGroupReportGrader',
        },
        {
            label: 'Uitv. grp. prijs',
            badgeText: '',
            value: 'grading-uitvGrpPrijs',
            key: 'compensationPayoutReportGraderGroupSetting',
        },
        {
            label: 'Uitv. organisatie ID',
            badgeText: '',
            value: 'grading-uitvOrganisatieId',
            key: 'gradingOrganizationTxcsId',
        },
        {
            label: 'Uitv. organisatienaam',
            badgeText: '',
            value: 'grading-uitvOrganisatienaam',
            key: 'gradingOrganizationName',
        },
        {
            label: 'Uitv. org. relatienr',
            badgeText: '',
            value: 'grading-uitvOrgRelatienr',
            key: 'gradingOrganizationRelationNumber',
        },
        {
            label: 'Uitv. org. prijs',
            badgeText: '',
            value: 'grading-uitvOrgPrijs',
            key: 'compensationPayoutReportGraderOrganizationSetting',
        },
        {
            label: 'Uitv. org. emailadres',
            badgeText: '',
            value: 'grading-uitvOrgEmailadres',
            key: 'gradingOrganizationEmailAddressRequestInbox',
        },
        {
            label: 'Uitv. org. fin. email',
            badgeText: '',
            value: 'grading-uitvOrgFinEmail',
            key: 'gradingOrganizationEmailAddressPayouts',
        },
        {
            label: 'Uitv. grader ID',
            badgeText: '',
            value: 'grading-uitvGraderId',
            key: 'gradingPractitionerUid',
        },
        {
            label: 'Uitv. gradernaam',
            badgeText: '',
            value: 'grading-uitvGradernaam',
            key: 'gradingPractitionerName',
        },
        {
            label: 'Uitv. prijs',
            badgeText: '',
            value: 'grading-uitvPrijs',
            key: 'compensationPayoutGra',
        },
        {
            label: 'Uitv. relatienr',
            badgeText: '',
            value: 'grading-uitvRelatienr',
            key: 'graderEmploymentRelationNumber',
        },
        {
            label: 'Pers. emailadres',
            badgeText: '',
            value: 'grading-persEmailadres',
            key: 'gradingPractitionerEmailAddress',
        },
        {
            label: 'Financieel emailadres',
            badgeText: '',
            value: 'grading-financieelEmailadres',
            key: 'graderEmploymentEmailAddress',
        },
        {
            label: 'Diagnostische overweging',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-diagnostischeOverweging',
            key: 'gradingDiagnosisConsideration',
        },
        {
            label: 'NPDR Bevinding OD',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-npdrBevindingOd',
            key: 'bevindingenNpdrOd',
        },
        {
            label: 'NPDR Bevinding OS',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-npdrBevindingOs',
            key: 'bevindingenNpdrOs',
        },
        {
            label: 'Maculopathie OD',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-maculopathieOd',
            key: 'maculopathieOd',
        },
        {
            label: 'Maculopathie OS',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-maculopathieOs',
            key: 'maculopathieOs',
        },
        {
            label: 'Retinopathie OD',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-retinopathieOd',
            key: 'retinopathieOd',
        },
        {
            label: 'Retinopathie OS',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-retinopathieOs',
            key: 'retinopathieOs',
        },
        {
            label: 'Advies',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-advies',
            key: 'geadviseerdBeleid',
        },
        {
            label: 'Urgentie advies',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-urgentieAdvies',
            key: 'urgentie',
        },
        {
            label: 'Glaucoom Ja-Nee-Suspect',
            badgeText: translateKey('common.sensitiveData'),
            value: 'grading-glaucoomJaNeeSuspect',
            key: 'glaucoom',
        },
    ],
};

export const supervisie = {
    name: 'Supervisie',
    data: [
        {
            label: 'Verzenddatum',
            badgeText: '',
            value: 'supervisie-verzenddatum',
            key: 'supervisionDate',
        },
        {
            label: 'Reden geen uitb.',
            badgeText: '',
            value: 'supervisie-redenGeenUitb',
            key: 'supervisionPayoutError',
        },
        {
            label: 'Reden geen uitb. ingest.',
            badgeText: '',
            value: 'supervisie-redenGeenUitbIngest',
            key: 'supervisionPayoutMutationReason',
        },
        {
            label: 'Uitv. grp. naam',
            badgeText: '',
            value: 'supervisie-uitvGrpNaam',
            key: 'nameGroupSupervision',
        },
        {
            label: 'Uitv. grp. relatienr.',
            badgeText: '',
            value: 'supervisie-uitvGrpRelatienr',
            key: 'relationNumberGroupSupervision',
        },
        {
            label: 'Uitv. grp. fin. email',
            badgeText: '',
            value: 'supervisie-uitvGrpFinEmail',
            key: 'financialEmailAddressGroupSupervision',
        },
        {
            label: 'Uitv. grp. prijs',
            badgeText: '',
            value: 'supervisie-uitvGrpPrijs',
            key: 'compensationPayoutSupervisionGroupSetting',
        },
        {
            label: 'Uitv. organisatie ID',
            badgeText: '',
            value: 'supervisie-uitvOrganisatieId',
            key: 'supervisionOrganizationTxcsId',
        },
        {
            label: 'Uitv. organisatienaam',
            badgeText: '',
            value: 'supervisie-uitvOrganisatienaam',
            key: 'supervisionOrganizationName',
        },
        {
            label: 'Uitv. org. emailadres',
            badgeText: '',
            value: 'supervisie-uitvOrgEmailadres',
            key: 'supervisionOrganizationEmailAddressRequestInbox',
        },
        {
            label: 'Uitv. org. fin. email',
            badgeText: '',
            value: 'supervisie-uitvOrgFinEmail',
            key: 'supervisionOrganizationEmailAddressPayouts',
        },
        {
            label: 'Uitv. supervisor ID',
            badgeText: '',
            value: 'supervisie-uitvSupervisorId',
            key: 'supervisionPractitionerUid',
        },
        {
            label: 'Uitv. supervisornaam',
            badgeText: '',
            value: 'supervisie-uitvSupervisornaam',
            key: 'supervisionPractitionerName',
        },
        {
            label: 'Uitv. prijs',
            badgeText: '',
            value: 'supervisie-uitvPrijs',
            key: 'compensationPayoutSupervisor',
        },
        {
            label: 'Uitv. relatienr',
            badgeText: '',
            value: 'supervisie-uitvRelatienr',
            key: 'supervisorEmploymentRelationNumber',
        },
        {
            label: 'Toelichting kwaliteitscontrole',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-toelichtingKwaliteitscontrole',
            key: 'supervisionToelichtingKwaliteitscontrole',
        },
        {
            label: 'NPDR Bevinding OD',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-npdrBevindingOd',
            key: 'supervisionBevindingenNpdrOd',
        },
        {
            label: 'NPDR Bevinding OS',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-npdrBevindingOs',
            key: 'supervisionBevindingenNpdrOs',
        },
        {
            label: 'Maculopathie OD',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-maculopathieOd',
            key: 'supervisionMaculopathieOd',
        },
        {
            label: 'Maculopathie OS',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-maculopathieOs',
            key: 'supervisionMaculopathieOs',
        },
        {
            label: 'Retinopathie OD',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-retinopathieOd',
            key: 'supervisionRetinopathieOd',
        },
        {
            label: 'Retinopathie OS',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-retinopathieOs',
            key: 'supervisionRetinopathieOs',
        },
        {
            label: 'Advies',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-advies',
            key: 'supervisionGeadviseerdBeleid',
        },
        {
            label: 'Urgentie advies',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-urgentieAdvies',
            key: 'supervisionUrgentie',
        },
        {
            label: 'Pers. emailadres',
            badgeText: '',
            value: 'supervisie-persEmailadres',
            key: 'supervisionPractitionerEmailAddress',
        },
        {
            label: 'Financieel emailadres',
            badgeText: '',
            value: 'supervisie-financieelEmailadres',
            key: 'supervisorEmploymentEmailAddress',
        },
        {
            label: 'Kwaliteit biometrie',
            badgeText: '',
            value: 'supervisie-kwaliteitBiometrie',
            key: 'supervisionAccessmentBiometrics',
        },
        {
            label: 'Diagnostische overweging',
            badgeText: translateKey('common.sensitiveData'),
            value: 'supervisie-diagnostischeOverweging',
            key: 'supervisionDiagnosisConsideration',
        },
    ],
};

export const consult = {
    name: 'Consult',
    data: [
        {
            label: 'Verzenddatum',
            badgeText: '',
            value: 'consult-verzenddatum',
            key: 'consultDate',
        },
        {
            label: 'Reden geen uitb.',
            badgeText: '',
            value: 'consult-redenGeenUitb',
            key: 'consultPayoutError',
        },
        {
            label: 'Reden geen uitb. ingest.',
            badgeText: '',
            value: 'consult-redenGeenUitbIngest',
            key: 'consultPayoutMutationReason',
        },
        {
            label: 'Uitv. grp. naam',
            badgeText: '',
            value: 'consult-uitvGrpNaam',
            key: 'nameGroupReport',
        },
        {
            label: 'Uitv. grp. relatienr.',
            badgeText: '',
            value: 'consult-uitvGrpRelatienr',
            key: 'relationNumberGroupReportSpecialist',
        },
        {
            label: 'Uitv. grp. fin. email',
            badgeText: '',
            value: 'consult-uitvGrpFinEmail',
            key: 'financialEmailAddressGroupReportSpecialist',
        },
        {
            label: 'Uitv. grp. prijs',
            badgeText: '',
            value: 'consult-uitvGrpPrijs',
            key: 'compensationPayoutReportSpecialistGroupSetting',
        },
        {
            label: 'Uitv. organisatie ID',
            badgeText: '',
            value: 'consult-uitvOrganisatieId',
            key: 'consultOrganizationTxcsId',
        },
        {
            label: 'Uitv. organisatienaam',
            badgeText: '',
            value: 'consult-uitvOrganisatienaam',
            key: 'consultOrganizationName',
        },
        {
            label: 'Uitv. org. relatienr',
            badgeText: '',
            value: 'consult-uitvOrgRelatienr',
            key: 'consultOrganizationRelationNumber',
        },
        {
            label: 'Uitv. org. prijs',
            badgeText: '',
            value: 'consult-uitvOrgPrijs',
            key: 'compensationPayoutReportSpecialistOrganizationSetting',
        },
        {
            label: 'Uitv. org. emailadres',
            badgeText: '',
            value: 'consult-uitvOrgEmailadres',
            key: 'consultOrganizationEmailAddressRequestInbox',
        },
        {
            label: 'Uitv. org. fin. email',
            badgeText: '',
            value: 'consult-uitvOrgFinEmail',
            key: 'consultOrganizationEmailAddressPayouts',
        },
        {
            label: 'Uitv. specialist ID',
            badgeText: '',
            value: 'consult-uitvSpecialistId',
            key: 'consultPractitionerUid',
        },
        {
            label: 'Uitv. specialistnaam',
            badgeText: '',
            value: 'consult-uitvSpecialistnaam',
            key: 'consultPractitionerName',
        },
        {
            label: 'Uitv. prijs',
            badgeText: '',
            value: 'consult-uitvPrijs',
            key: 'compensationPayoutReportSpec',
        },
        {
            label: 'Uitv. relatienr',
            badgeText: '',
            value: 'consult-uitvRelatienr',
            key: 'consultPractitionerEmploymentRelationNumber',
        },
        {
            label: 'Pers. emailadres',
            badgeText: '',
            value: 'consult-persEmailadres',
            key: 'consultPractitionerEmailAddress',
        },
        {
            label: 'Financieel emailadres',
            badgeText: '',
            value: 'consult-financieelEmailadres',
            key: 'consultPractitionerEmploymentEmailAddress',
        },
        {
            label: 'Bez. spec. nodig?',
            badgeText: translateKey('common.sensitiveData'),
            value: 'consult-bezSpecNodig',
            key: 'consultBezoekAanSpecialistNodig',
        },
        {
            label: 'Beleid',
            badgeText: translateKey('common.sensitiveData'),
            value: 'consult-beleid',
            key: 'consultBeleid',
        },
    ],
};

export const factuurOrgGrp = {
    name: 'Factuur Org/Grp',
    data: [
        {
            label: 'Te fact. bedrag',
            badgeText: '',
            value: 'factuurOrgGrp-teFactBedrag',
            key: 'invoiceAmount',
        },
        {
            label: 'Batch-run',
            badgeText: '',
            value: 'factuurOrgGrp-batchRun',
            key: 'invoiceRunNumber',
        },
    ],
};

export const factuurPatient = {
    name: 'Factuur Patient',
    data: [
        {
            label: 'Te fact. bedrag',
            badgeText: '',
            value: 'factuurPatient-teFactBedrag',
            key: 'patientInvoiceAmount',
        },
        {
            label: 'Batch-run',
            badgeText: '',
            value: 'factuurPatient-batchRun',
            key: 'patientInvoiceRunNumber',
        },
    ],
};

export const declaratie = {
    name: 'Declaratie',
    data: [
        {
            label: 'Te decl. bedrag',
            badgeText: '',
            value: 'declaratie-teDeclBedrag',
            key: 'declarationAmount',
        },
        {
            label: 'UZOVI',
            badgeText: '',
            value: 'declaratie-uzovi',
            key: 'uzoviCode',
        },
        {
            label: 'Verzekeraar',
            badgeText: '',
            value: 'declaratie-verzekeraar',
            key: 'insurer',
        },
        {
            label: 'Batch-run',
            badgeText: '',
            value: 'declaratie-batchRun',
            key: 'runNumber',
        },
    ],
};

export const uitbetaling = {
    name: 'Uitbetaling',
    data: [
        {
            label: 'Relatienr. Aanvrager',
            badgeText: '',
            value: 'uitbetaling-relatienrAanvrager',
            key: 'payoutRelationNumberRequester',
        },
        {
            label: 'Aanvraag',
            badgeText: '',
            value: 'uitbetaling-aanvraag',
            key: 'payoutAmountRequester',
        },
        {
            label: 'Aanvraag Batch-run',
            badgeText: '',
            value: 'uitbetaling-aanvraagBatchRun',
            key: 'runNumberRequester',
        },
        {
            label: 'Relatienr. biometrie',
            badgeText: '',
            value: 'uitbetaling-relatienrBiometrie',
            key: 'payoutRelationNumberBiometrician',
        },
        {
            label: 'Biometrie',
            badgeText: '',
            value: 'uitbetaling-biometrie',
            key: 'payoutAmountBiometrician',
        },
        {
            label: 'Biometrie Batch-run',
            badgeText: '',
            value: 'uitbetaling-biometrieBatchRun',
            key: 'runNumberBiometrician',
        },
        {
            label: 'Relatienr. grader',
            badgeText: '',
            value: 'uitbetaling-relatienrGrader',
            key: 'payoutRelationNumberGrader',
        },
        {
            label: 'Grading',
            badgeText: '',
            value: 'uitbetaling-grading',
            key: 'payoutAmountGrader',
        },
        {
            label: 'Grader Batch-run',
            badgeText: '',
            value: 'uitbetaling-graderBatchRun',
            key: 'runNumberGrader',
        },
        {
            label: 'Relatienr. specialist',
            badgeText: '',
            value: 'uitbetaling-relatienrSpecialist',
            key: 'payoutRelationNumberSpecialist',
        },
        {
            label: 'Consult',
            badgeText: '',
            value: 'uitbetaling-consult',
            key: 'payoutAmountSpecialist',
        },
        {
            label: 'Specialist Batch-run',
            badgeText: '',
            value: 'uitbetaling-specialistBatchRun',
            key: 'runNumberSpecialist',
        },
        {
            label: 'Relatienr. supervisie',
            badgeText: '',
            value: 'uitbetaling-relatienrSupervisie',
            key: 'payoutRelationNumberSupervisor',
        },
        {
            label: 'Supervisor',
            badgeText: '',
            value: 'uitbetaling-supervisor',
            key: 'payoutAmountSupervisor',
        },
        {
            label: 'Supervisor Batch-run',
            badgeText: '',
            value: 'uitbetaling-supervisorBatchRun',
            key: 'runNumberSupervisor',
        },
    ],
};

export const instellingen = {
    name: 'Instellingen',
    data: [
        {
            label: 'Org. bio. altern. bek.',
            badgeText: '',
            value: 'instellingen-orgBioAlternBek',
            key: 'procedureServiceOrganizationAlternativeFinancing',
        },
        {
            label: 'Org. grad/spec. altern. bek.',
            badgeText: '',
            value: 'instellingen-orgGradSpecAlternBek',
            key: 'reportServiceOrganizationAlternativeFinancing',
        },
        {
            label: 'Org. bio. fact.',
            badgeText: '',
            value: 'instellingen-orgBioFact',
            key: 'procedureServiceOrganizationInvoice',
        },
        {
            label: 'Org. grad/spec. fact.',
            badgeText: '',
            value: 'instellingen-orgGradSpecFact',
            key: 'reportServiceOrganizationInvoice',
        },
        {
            label: 'Grp. altern. bek.',
            badgeText: '',
            value: 'instellingen-grpAlternBek',
            key: 'serviceGroupAlternativeFinancing',
        },
        {
            label: 'Grp. fact.',
            badgeText: '',
            value: 'instellingen-grpFact',
            key: 'serviceGroupFact',
        },
        {
            label: 'Aanvr. grp',
            badgeText: '',
            value: 'instellingen-aanvrGrp',
            key: 'groupName',
        },
        {
            label: 'Uitv. biom. grp',
            badgeText: '',
            value: 'instellingen-uitvBiomGrp',
            key: 'nameGroupProcedure',
        },
        {
            label: 'Uitv. gr/cs. grp',
            badgeText: '',
            value: 'instellingen-uitvGrCsGrp',
            key: 'nameGroupReport',
        },
        {
            label: 'Patient facturatie',
            badgeText: '',
            value: 'instellingen-patientFacturatie',
            key: 'serviceIsPatientInvoicing',
        },
    ],
};

export const preSelectedValuesPayouts = {
    analistSelectValue: [],
    declaratieSelectValue: [],
    factuurOrgGrpSelectValue: [],
    factuurPatientSelectValue: [],
    patientSelectValue: [],
    uitbetalingSelectValue: [
        'uitbetaling-relatienrAanvrager',
        'uitbetaling-aanvraag',
        'uitbetaling-aanvraagBatchRun',
        'uitbetaling-relatienrBiometrie',
        'uitbetaling-biometrie',
        'uitbetaling-biometrieBatchRun',
        'uitbetaling-relatienrGrader',
        'uitbetaling-grading',
        'uitbetaling-graderBatchRun',
        'uitbetaling-relatienrSpecialist',
        'uitbetaling-consult',
        'uitbetaling-specialistBatchRun',
        'uitbetaling-relatienrSupervisie',
        'uitbetaling-supervisor',
        'uitbetaling-supervisorBatchRun',
    ],
};

export const preSelectedValuesFunding = {
    analistSelectValue: [],
    declaratieSelectValue: [
        'declaratie-teDeclBedrag',
        'declaratie-uzovi',
        'declaratie-verzekeraar',
        'declaratie-batchRun',
    ],
    factuurOrgGrpSelectValue: ['factuurOrgGrp-teFactBedrag', 'factuurOrgGrp-batchRun'],
    factuurPatientSelectValue: ['factuurPatient-teFactBedrag', 'factuurPatient-batchRun'],
    patientSelectValue: ['patient-patientId', 'patient-huisartsnaam'],
    uitbetalingSelectValue: [],
};

export const preSelectedValuesComplete = {
    analistSelectValue: [
        'analist-uitvOrganisatieId',
        'analist-uitvOrganisatienaam',
        'analist-uitvAnalistId',
        'analist-uitvAnalistnaam',
    ],
    declaratieSelectValue: [
        'declaratie-teDeclBedrag',
        'declaratie-uzovi',
        'declaratie-verzekeraar',
        'declaratie-batchRun',
    ],
    factuurOrgGrpSelectValue: ['factuurOrgGrp-teFactBedrag', 'factuurOrgGrp-batchRun'],
    factuurPatientSelectValue: ['factuurPatient-teFactBedrag', 'factuurPatient-batchRun'],
    patientSelectValue: ['patient-patientId', 'patient-huisartsnaam'],
    uitbetalingSelectValue: [
        'uitbetaling-relatienrAanvrager',
        'uitbetaling-aanvraag',
        'uitbetaling-aanvraagBatchRun',
        'uitbetaling-relatienrBiometrie',
        'uitbetaling-biometrie',
        'uitbetaling-biometrieBatchRun',
        'uitbetaling-relatienrGrader',
        'uitbetaling-grading',
        'uitbetaling-graderBatchRun',
        'uitbetaling-relatienrSpecialist',
        'uitbetaling-consult',
        'uitbetaling-specialistBatchRun',
        'uitbetaling-relatienrSupervisie',
        'uitbetaling-supervisor',
        'uitbetaling-supervisorBatchRun',
    ],
};

export const otherPreSelectedValues = {
    aanvraagSelectValue: [
        'aanvraag-verzenddatum',
        'aanvraag-redenGeenUitb',
        'aanvraag-redenGeenUitbIngest',
        'aanvraag-aanvOrganisatieId',
        'aanvraag-aanvOrganisatienaam',
        'aanvraag-verwijstNaar',
        'aanvraag-aanvOrgRelatienr',
        'aanvraag-aanvOrgPrijs',
        'aanvraag-aanvOrgEmailadres',
        'aanvraag-aanvOrgFinEmail',
        'aanvraag-aanvGrpNaam',
        'aanvraag-aanvGrpRelatienr',
        'aanvraag-aanvGrpFinEmail',
        'aanvraag-aanvGrpPrijs',
        'aanvraag-aanvragerI',
        'aanvraag-aanvragernaam',
        'aanvraag-uitvPrijs',
        'aanvraag-uitvRelatienr',
        'aanvraag-persEmailadres',
        'aanvraag-financieelEmailadres',
    ],
    biometrieSelectValue: [
        'biometrie-verzenddatum',
        'biometrie-redenGeenUitb',
        'biometrie-redenGeenUitbIngest',
        'biometrie-uitvGrpNaam',
        'biometrie-uitvGrpRelatienr',
        'biometrie-uitvGrpFinEmail',
        'biometrie-uitvGrpPrijs',
        'biometrie-uitvOrganisatieId',
        'biometrie-uitvOrganisatienaam',
        'biometrie-uitvOrgRelatienr',
        'biometrie-uitvOrgPrijs',
        'biometrie-uitvOrgEmailadres',
        'biometrie-uitvOrgFinEmail',
        'biometrie-uitvBiometristId',
        'biometrie-uitvBiometristnaam',
        'biometrie-uitvPrijs',
        'biometrie-uitvRelatienr',
        'biometrie-persEmailadres',
        'biometrie-financieelEmailadres',
    ],
    consultSelectValue: [
        'consult-verzenddatum',
        'consult-redenGeenUitb',
        'consult-redenGeenUitbIngest',
        'consult-uitvGrpNaam',
        'consult-uitvGrpRelatienr',
        'consult-uitvGrpFinEmail',
        'consult-uitvGrpPrijs',
        'consult-uitvOrganisatieId',
        'consult-uitvOrganisatienaam',
        'consult-uitvOrgRelatienr',
        'consult-uitvOrgPrijs',
        'consult-uitvOrgEmailadres',
        'consult-uitvOrgFinEmail',
        'consult-uitvSpecialistId',
        'consult-uitvSpecialistnaam',
        'consult-uitvPrijs',
        'consult-uitvRelatienr',
        'consult-persEmailadres',
        'consult-financieelEmailadres',
    ],
    gradingSelectValue: [
        'grading-verzenddatum',
        'grading-redenGeenUitb',
        'grading-redenGeenUitbIngest',
        'grading-uitvGrpNaam',
        'grading-uitvGrpRelatienr',
        'grading-uitvGrpFinEmail',
        'grading-uitvGrpPrijs',
        'grading-uitvOrganisatieId',
        'grading-uitvOrganisatienaam',
        'grading-uitvOrgRelatienr',
        'grading-uitvOrgPrijs',
        'grading-uitvOrgEmailadres',
        'grading-uitvOrgFinEmail',
        'grading-uitvGraderId',
        'grading-uitvGradernaam',
        'grading-uitvPrijs',
        'grading-uitvRelatienr',
        'grading-persEmailadres',
        'grading-financieelEmailadres',
    ],
    instellingenSelectValue: [
        'instellingen-orgBioAlternBek',
        'instellingen-orgGradSpecAlternBek',
        'instellingen-orgBioFact',
        'instellingen-orgGradSpecFact',
        'instellingen-grpAlternBek',
        'instellingen-grpFact',
        'instellingen-aanvrGrp',
        'instellingen-uitvBiomGrp',
        'instellingen-uitvGrCsGrp',
        'instellingen-patientFacturatie',
    ],
    procesSelectValue: [
        'proces-procesId',
        'proces-txcsProcesId',
        'proces-migratiedatum',
        'proces-mogelijkTestgeval',
        'proces-dienst',
        'proces-dienstsoort',
        'proces-indirecteAanvraag',
        'proces-creatiedatum',
        'proces-status',
        'proces-aanvraagVerzonden',
        'proces-sluitdatum',
        'proces-redenGeenBekosting',
        'proces-redenGeenBekIngest',
        'proces-bekostingsfout',
        'proces-afhandelingsinformatie',
        'proces-andersDoorverwezen',
        'proces-alsnogDoorverwijzen',
        'proces-geholpen',
        'proces-leerzaam',
        'proces-consult',
        'proces-aanvraagOntvanger',
    ],

    supervisieSelectValue: [
        'supervisie-verzenddatum',
        'supervisie-redenGeenUitb',
        'supervisie-redenGeenUitbIngest',
        'supervisie-uitvGrpNaam',
        'supervisie-uitvGrpRelatienr',
        'supervisie-uitvGrpFinEmail',
        'supervisie-uitvGrpPrijs',
        'supervisie-uitvOrganisatieId',
        'supervisie-uitvOrganisatienaam',
        'supervisie-uitvOrgEmailadres',
        'supervisie-uitvOrgFinEmail',
        'supervisie-uitvSupervisorId',
        'supervisie-uitvSupervisornaam',
        'supervisie-uitvPrijs',
        'supervisie-uitvRelatienr',
        'supervisie-persEmailadres',
        'supervisie-financieelEmailadres',
        'supervisie-kwaliteitBiometrie',
    ],
};

export const privacySensitiveDataColums = [
    'biometrie-reversTestAfg',
    'biometrie-ketenpatient',
    'biometrie-protocol',
    'biometrie-gedruppeld',
    'grading-diagnostischeOverweging',
    'grading-npdrBevindingOd',
    'grading-npdrBevindingOs',
    'grading-maculopathieOd',
    'grading-maculopathieOs',
    'grading-retinopathieOd',
    'grading-retinopathieOs',
    'grading-advies',
    'grading-urgentieAdvies',
    'grading-glaucoomJaNeeSuspect',
    'supervisie-toelichtingKwaliteitscontrole',
    'supervisie-npdrBevindingOd',
    'supervisie-npdrBevindingOs',
    'supervisie-maculopathieOd',
    'supervisie-maculopathieOs',
    'supervisie-retinopathieOd',
    'supervisie-retinopathieOs',
    'supervisie-advies',
    'supervisie-urgentieAdvies',
    'supervisie-diagnostischeOverweging',
    'consult-bezSpecNodig',
    'consult-beleid',
];
